// メッセージボックス_OK_CANCEL用棚
import React, { useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';

interface Props {
  label: string;
  body: JSX.Element;
  ok: string;
  okCallback: (event: React.MouseEvent) => void;
  cancel: string;
  cancelCallback: (event: React.MouseEvent) => void;
  open: boolean;
}

const DialogConfirm: React.FC<Props> = ({
  label,
  body,
  ok,
  okCallback,
  cancel,
  cancelCallback,
  open,
}) => {
  const handleClickOk = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    okCallback(event);
  };
  const handleClickCancel = useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      cancelCallback(event);
    },
    []
  );

  return (
    <div className="dialog-confirm">
      <div className="dialog-mask" style={{ display: open ? 'block' : 'none' }}></div>
      <div className="dialog-section" style={{ display: open ? 'block' : 'none' }}>
        <div className="dialog-inner">
          <div className="dialog-contents">
            <h3>{label}</h3>
            <div className="dialog-body">{body}</div>
            <Row className="dialog-button">
              <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                <button
                  className="c-btn btn-large btn-red btn-ok"
                  type="button"
                  onClick={handleClickOk}
                >
                  {ok}
                </button>
              </Col>
              <Col xl={6} lg={6} md={6} sm={6} xs={6}>
                <button
                  className="c-btn btn-large btn-main-color btn-cancel me-0 ms-auto"
                  type="button"
                  onClick={handleClickCancel}
                >
                  {cancel}
                </button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DialogConfirm;
